module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "pub_dialog",
    attrs: {
      "visible": _vm.isQuotationRecord,
      "show-close": false,
      "width": "96%",
      "top": "50px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isQuotationRecord = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v("报价记录")]), _vm._v(" "), _c('li', [_c('el-button', {
          staticStyle: {
            "margin-top": "-10px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.closeQuotationRecord
          }
        }, [_vm._v("关 闭")])], 1)])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-row', {
    staticClass: "drawerBaojiaDiv"
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.getDataAllList,
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "报价记录",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            on: {
              "click": function($event) {
                return _vm.endQuotationTime(scope.row)
              }
            }
          }, [_vm._v(_vm._s(scope.row.QuoteTime)), (scope.row.Status == '已中标') ? _c('strong', [_vm._v("-已中标")]) : _vm._e()])]
        }
      }])
    })], 1)]
  ], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "drawerInformation"
  }, [_c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "divBasics"
  }, [_c('p', [_vm._v("竞价品类:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.BrandType))])]), _vm._v(" "), _c('p', [_vm._v("竞价品牌:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.Brand))])]), _vm._v(" "), _c('p', [_vm._v("状态:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.Status))])])]), _vm._v(" "), _c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("报价商品")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "data": _vm.formDetails.QuotationGoods,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.GoodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "label": "商品型号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.GoodsCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Counts",
      "label": "风格",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Style))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singleprice",
      "label": "单位",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Unit))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PaidPrice",
      "label": "参考图片/图纸",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          style: ({
            color: scope.row.Imgs.length == 0 ? '#ccc' : '#F56C6C'
          }),
          on: {
            "click": function($event) {
              return _vm.seeQuoteThumbnail(scope.row.Imgs)
            }
          }
        }, [_vm._v("查看(" + _vm._s(scope.row.Imgs.length) + ")张")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Counts",
      "label": "数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Counts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PaidPrice",
      "label": "单价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.UnitPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Counts",
      "label": "备注说明",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Remark))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isQuotationRecord) ? _c('div', {
    staticClass: "total"
  }, [_c('span', [_c('strong', [_vm._v("总计：")])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.totalNumber))])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.totalUnitPrice))])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.theSum))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divBasics"
  }, [_c('p', [_vm._v("竞标价:　"), _c('span', [_vm._v("¥ " + _vm._s(_vm.formDetails.BidPrice))])]), _vm._v(" "), _c('p', [_vm._v("平台佣金:　"), _c('span', [_vm._v(_vm._s((_vm.formDetails.Commission * 100).toFixed(2)) + "% ")])]), _vm._v(" "), _c('p', [_vm._v("平台应得佣金:　"), _c('span', [_vm._v("¥ " + _vm._s(_vm.formDetails.TotalbidPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("报价要求")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "classRequestForQuotation"
  }, [_c('p', [_vm._v("报价有效截止日:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.QuoteEffectiveDate))])]), _vm._v(" "), _c('p', [_vm._v("计划送货时间：付款后 "), _c('span', [_vm._v(_vm._s(_vm.formDetails.DeliveryDaysAfterPay))]), _vm._v(" 天后送货")])]), _vm._v(" "), _c('div', {
    staticClass: "classRequestForQuotation"
  }, [_c('p', [_vm._v("备注:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.QuoteRemark))])])])]), _vm._v(" "), (_vm.formDetails.Status == '已中标') ? _c('div', [_c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("客户服务要求")]), _vm._v(" "), _c('div', {
    staticClass: "classCustomerService"
  }, [_c('p', [_vm._v("配送地址:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.DeliveryZone))])]), _vm._v(" "), _c('p', [_vm._v("上楼方式:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.UpstairsType))])]), _vm._v(" "), _c('p', [_vm._v("楼层:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.FloorNumber))])]), _vm._v(" "), _c('p', [_vm._v("是否需要发票:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.IsNeedInvoice))])])]), _vm._v(" "), _c('div', {
    staticClass: "divBasics"
  }, [_c('p', [_vm._v("是否需要安装:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.IsNeedInstallation))])]), _vm._v(" "), _c('p', [_vm._v("运费承担:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.IsBearDeliveryFee))])]), _vm._v(" "), _c('p', [_vm._v("期望送货日期:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.DeliveryDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "divBasics"
  }, [_c('p', [_vm._v("客户要求备注:　"), _c('span', [_vm._v(_vm._s(_vm.formDetails.InquiryRemark))])])])]) : _vm._e(), _vm._v(" "), (_vm.formDetails.Status != '已中标') ? _c('div', {
    staticClass: "preservation_div"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isQuotationRecord = false
      }
    }
  }, [_vm._v("取消")])], 1) : _vm._e(), _vm._v(" "), (_vm.formDetails.Status == '已中标') ? _c('div', {
    staticClass: "preservation_div"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.endModifyQuotation
    }
  }, [_vm._v("修改报价单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.endBusinessQuotation
    }
  }, [_vm._v("已与客户沟通确认，生成订单发送给客户")])], 1) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('BusinessQuotation', {
    ref: "refBusinessQuotation",
    attrs: {
      "inquiryId": _vm.inquiryId,
      "inquiryNo": _vm.inquiryNo,
      "formDetails": _vm.formDetails
    },
    on: {
      "add-comment": _vm.appendComment
    }
  }), _vm._v(" "), _c('ViewPicture', {
    ref: "refViewPicture"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97a7e5c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderManagement/QuotationRecord.vue
// module id = 1734
// module chunks = 3